<template>
    <a-card size="small" title="回调数据">
        <searchE @handleSearch="handleSubmit"></searchE>
        <tableE ref="branchTable"></tableE>
    </a-card>
</template>
<script>
import searchE from './search'
import tableE from './table'
export default {
    methods: {
        handleSubmit(searchP){
            this.$refs.branchTable.handleSearch(searchP);
        }
    },
    components:{
        searchE,
        tableE
    },
};
</script>
